export const CARD_SPEC = {
  version: 'v1',
  canvas: { w: 1200, h: 1800 },
  front: {
    plate: { x: 250, y: 1470, w: 700, h: 228 },
    nameSafe: { x: 320, y: 1510, w: 560, h: 148 },
    character: {
      centerX: 640,
      baselineY: 1470,
      fit: { w: 640, h: 860 },
      max: { w: 640, h: 860 },
    },
    nameFont: { min: 96, max: 112, color: '#F8E9C5' },
  },
  back: {
    name: { x: 300, y: 330, w: 600, h: 150 },
    nameFont: { min: 96, max: 112, color: '#F8E9C5' },
    meaning: {
      x: 205,
      y: 675,
      w: 790,
      h: 650,
      fontSize: 44,
      lineHeight: 1.55,
      color: '#4B3520',
    },
    footer: {
      x: 300,
      y: 1630,
      w: 600,
      h: 60,
      text: 'www.ko-ready.com',
      fontSize: 32,
      color: '#F8E9C5',
    },
  },
  preview: { w: 480, h: 720 },
};
